import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Course } from 'src/app/models/course';
import { CourseEnrollment } from 'src/app/models/course-enrollment';
import { CoursesService } from 'src/app/services/courses/courses.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';

import { CourseEditComponent } from '../course-edit/course-edit.component';
import { CourseEnrollComponent } from '../course-enroll/course-enroll.component';
import { NamePipe } from 'src/app/pipes/name.pipe';
import { EnrollPipe } from 'src/app/pipes/enroll.pipe';

@Component({
  selector: 'li-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatInputModule,
    CourseEditComponent,
    CourseEnrollComponent,
    NamePipe,
    EnrollPipe
  ]
})
export class CourseListComponent implements OnInit {
  public loading: boolean = true;
  public courses: Course[] = [];
  public selectedCourse?: Course;
  public viewingCourse?: Course;
  public viewingCourseStudents: CourseEnrollment[] = [];
  public courseEnrollment: CourseEnrollment[] = [];
  public dataSource = new MatTableDataSource<Course>();

  constructor(private coursesService: CoursesService) {}

  ngOnInit() {
    this.dataSource.filterPredicate = (record: any, filter: string) => {
      if (filter.length < 2) return true;
      const searchIn = (record.name + record.diffname + record.cid).toLowerCase();
      return searchIn.includes(filter.toLowerCase());
    };
    this.getData();
  }

  formatAge(begin: number, end: number): string {
    if (begin === 0 && end === 99) {
      return '(alle Altersgruppen)';
    }

    if (begin > 0 && end === 99) {
      return `(ab ${begin}J.)`;
    }

    if (begin >= 0 && end > begin && end !== 99) {
      return `(${begin}-${end}J.)`;
    }

    if (begin === 0 && end < 99) {
      return `(bis ${end}J.)`;
    }

    return `(${begin}-${end}J.)`;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  add(): void {
    this.selectedCourse = <Course>{};
  }

  edit(course: Course): void {
    this.selectedCourse = course;
  }

  delete(course: Course): void {
    if (!confirm(`Soll der Kurs "${course.name}" wirklich gelöscht werden?`)) {
      return;
    }

    this.coursesService.del(course).subscribe(() => this.getData());
  }

  showStudents(course: Course): void {
    const now = new Date();
    this.viewingCourse = course;
    this.viewingCourseStudents = course.students.filter(s => new Date(s.begin) < now && new Date(s.end) > now) ?? [];
  }

  commit(): void {
    this.selectedCourse = undefined;
    this.viewingCourseStudents = [];
    this.getData();
  }

  private getData(): void {
    this.coursesService.get().subscribe({
      next: courses => {
        this.loading = false;
        this.courses = courses;
        this.dataSource.data = this.courses;
      },
      error: err => console.error(err)
    });
  }

  public formatColor(color: string): string {
    if (!color) return '#ffffff';
    return color.startsWith('#') ? color : `#${color}`;
  }
}
